// extracted by mini-css-extract-plugin
export var chevronIcon = "_9v-2";
export var teamName = "_9v-1";
export var teamSwitcherButton = "_9v-0";